<template>
  <div class="expired-app">
    <div>
      <div>
        <br>
        <h3>O período de teste gratuito do app {{ name }} foi encerrado</h3>
        <br>
        <p>Para mais informações, entre em contato com o suporte.</p>
        <slot/>

      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'ExpiredApp',
    props: ['name'],
  }
</script>

<style scoped>
  .expired-app {
    height: 50vh;
    width: 100%;
    /*background: rgba(200, 187, 187, 0.53);*/
    padding: 0;
  }

  .expired-app > div {
    height: 100%;
    display: flex;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  /* modal */
  .expired-app > div > div {
    position: relative;
    background: white;
    width: 50%;
    /*border: 2px solid black;*/
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0px 4px 50px rgba(153, 153, 153, 0.25);
  }

  .go-back {
    position: absolute;
    top: 10px;
    left: 10px;
    /*color: black;*/
  }

</style>
